import setAuthToken from "../config/setAuthToken";
import { getRequest, postRequest } from "./ApiRequest";

import { _auth } from "./_auth";

export const _employees = {
  async getEmployeesByTenantId() {
    let profile = _auth.getUserProfile();

    let data = {
      tenantId: profile.tenantId,
    };

    try {
      let token = _auth.getUserToken("jwtToken");
      setAuthToken(token.replace(/"([^"]+(?="))"/g, "$1"));
      let response = await postRequest("get-all-employees", data);
      console.log("get-all-employees 1", response);
      if (response && response.data) {
        console.log("get-all-employees 2", response.data.data);
        return response.data.data;
      } else {
        return [];
      }
    } catch (e) {
      return [];
    }
  },
};
